<template>
  <div class="page">
    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <!-- <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div>  -->
              <div v-html="formattedDescriptionNo(item.description_1)" class="description"></div>
              <div class="card-header-2">
                <img :src="item.image_1" alt="Content Image" class="image" />
              </div>
              <div v-html="formattedDescriptionNo(item.description_2)" class="description"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <!-- Contact Section (moved to the right) -->
      <!-- <div class="contact-container">
        <h2>Contact Information</h2>
        <div class="contact-info">
          <i class="fas fa-phone"></i>
          <p>Phone: +86 19883038871</p>
        </div>
        <div class="contact-info">
          <i class="fas fa-envelope"></i>
          <p>Email: dankao.chen@nxtech.pub</p>
        </div>
      </div> -->
    </div>

</template>

<style src="@/assets/css/news.css" scoped></style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image_1: require("@/assets/img/News/001/Logo.jpg"),
            title: "宁波云翰虹章信息科技有限责任公司正式成立",
            description_1:`
            2022年6月22日，宁波云翰虹章信息科技有限责任公司正式成立。该公司由一支拥有先进技术和深厚管理经验的青年团队创建，致力于在各行业领域利用先进技术为客户创造独特价值。`,
            description_2:`
            未来，云翰虹章公司将在影视、文化旅游、数字资产、AIGC等领域拓展业务，并持续投入研发，不断提升公司的技术水平和业务水平。`,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image_1: require("@/assets/img/News/001/Logo.jpg"),
            title:
              "Rosy Nebula Information Technology Co., Ltd. was established",
            description_1:`
              On June 22, 2022, Rosy Nebula Information Technology Co., Ltd. was established. Rosy Nebula was founded by a youth team proficient in cutting-edge technologies with rich management experience, and is engaged in creating unique value by utilizing advanced technology in various industry sectors.`,
            description_2:`
              In the future, Rosy Nebula will expand its business in the fields of film and television, cultural tourism, digital assets, AIGC, etc. The company will also continue to invest in research and development to continuously improve the company's technology and business level.`,
          },
          // Add more items as needed
        ],
      },
    };
  },
  // mixins: [],
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
